// @flow strict

import type {EmailAction} from 'src/action-creators/email';
import type {NodeSchedule} from 'src/types/node-schedule';
import type {NoteWriteback} from 'src/types/note-writeback';

//$FlowFixMe[nonstrict-import]
import type {EmailAttachment} from 'src/types/email';
import {
  RECEIVE_EMAIL_INFO,
  UPDATE_EMAIL_INFO,
  RESET,
  UPDATE_NODE_SCHEDULE,
  UPDATE_NOTE_WRITEBACK,
} from 'src/action-creators/email';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {getDefaultNoteWritebackState} from 'src/utils/note-writeback';


export type EmailState = {
  subject: ?string,
  content_json: ?string,
  content_html: ?string,
  from_name: ?string,
  from_email: ?string,
  to_email: ?string,
  cc: Array<string>,
  bcc: Array<string>,
  content_subscription_category_id: ?number,
  content_subscription_reason: ?string,
  skip_subscription_link: boolean,
  attachments: Array<EmailAttachment>,
  chatbotsAttached: Array<string>,
  surveysAttached: Array<number>,
  ...NodeSchedule,
  ...NoteWriteback,
};

const initialState = {
  subject: null,
  content_json: '{}',
  content_html: null,
  from_name: null,
  from_email: null,
  to_email: null,
  cc: [],
  bcc: [],
  attachments: [],
  // We are initializing this as 4, since default marketing category id is 4.
  content_subscription_category_id: null,
  content_subscription_reason: null,
  skip_subscription_link: false,
  chatbotsAttached: [],
  surveysAttached: [],
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
  ...getDefaultNoteWritebackState(),
};

export default (
  state: EmailState = initialState,
  action: EmailAction,
): EmailState => {
  switch (action.type) {
    case UPDATE_EMAIL_INFO:
      const updatePayload = action.payload;
      return {
        ...state,
        ...updatePayload,
      };
    case RECEIVE_EMAIL_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NOTE_WRITEBACK:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      return {...initialState};
  }
  return state;
};
